module.exports = __webpack_public_path__ + "static/media/img30.32fda24e.jpg";